import { TmBaseError } from '@/core/error/tmBaseError'

export default class TmAbortError extends TmBaseError {
  public name = 'TmAbortError'

  constructor(message = 'AbortError') {
    super(message)
  }
}
